import * as C from '../common/constants';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { storeData } from '../common/app/actions';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      iconStyle: {
        padding: '10px',
        pointerEvents: 'auto',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      '@global': {
        '.MuiTooltip-tooltipPlacementTop': {
          backgroundColor: 'rgba(0,0,0,0) !important',
        },
      },
    })
);

const AnimationIcon = ({ data }): JSX.Element => {
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const { titleType, actionType, Icon, SVG } = data;

  const appData = useSelector((state: any) => state.app[C.APP_DATA]);
  const labels = appData?.labels;

  const isChecked = useSelector((state: any) => state.app[actionType]) || false;

  const onClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    dispatch(storeData(!isChecked, actionType));
  };

  const label = labels?.[`${titleType}Label`];

  if (SVG) {
    return (
      <Tooltip title={label} arrow placement="top">
        <SvgIcon
          className={classes.iconStyle}
          component={SVG}
          // fontSize={'large'}
          sx={{
            color: isChecked ? COLORS.white : COLORS.lightGrey,
            fontSize: { xs: 24, sm: 26, md: 30, lg: 36 },
          }}
          onClick={onClick}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={label} placement="top">
      <Icon
        onClick={onClick}
        // fontSize={'medium'}
        className={classes.iconStyle}
        sx={{
          color: isChecked ? COLORS.white : COLORS.lightGrey,
          fontSize: { xs: 24, sm: 26, md: 30, lg: 36 },
        }}
      />
    </Tooltip>
  );
};

export default AnimationIcon;
